import { styled } from "@mui/material/styles";
import { Select as MuiSelect, Typography } from "@mui/material";
import { SelectProps as MuiSelectProps } from "@mui/material";
import { FormControl, InputLabel, MenuItem } from "@mui/material";

interface SelectProps extends MuiSelectProps {
	label: string
	items: SelectitemData[]
}

const Select = ({ label, items, error, className, ...props }: SelectProps) => {

	return (
		<SelectWrapper fullWidth className={className}>
			<InputLabel error={error}>
				<Typography variant="body2">{label}</Typography>
			</InputLabel>

			<SelectContainer label={label} error={error} {...props}>
				{items.map((item: SelectitemData, key: number) => (
					<SelectItem value={item.value} key={key}>
						<Typography variant="body2">
							{item.label}
						</Typography>
					</SelectItem>
				))}
			</SelectContainer>
		</SelectWrapper>
	)
}

const SelectWrapper = styled(FormControl)(({ theme }) => ({
	label: {
		color: theme.palette.common.firstColor,
		transform: `translate(15px, 10px) scale(1)`,

		"&.MuiFormLabel-filled": {
			transform: `translate(15px, -9px) scale(0.75)`,
		}
	},

	'& label.Mui-focused, &.base-filled>label': {
		color: theme.palette.common.firstColor,
		transform: `translate(15px, -9px) scale(0.75)`,
	},

	"& .Mui-error p": {
		color: theme.palette.common.fourthColor,
	}
}))

const SelectContainer = styled(MuiSelect)(({ theme }) => ({
	".MuiSelect-select": {
		padding: "10px 15px",
	},

	fieldset: {
		borderColor: `${theme.palette.common.firstBorder} !important`,
	},

	"&.Mui-focused fieldset": {
		borderWidth: '1px !important',
		borderColor: `${theme.palette.common.firstColor}c0 !important`,
	},

	"&.Mui-error fieldset": {
		borderColor: `${theme.palette.common.fourthColor} !important`,
	},
}))

const SelectItem = styled(MenuItem)(({ theme }) => ({
	"&:hover": {
		backgroundColor: `${theme.palette.common.firstColor}10`,
	},

	"&.Mui-selected": {
		backgroundColor: `${theme.palette.common.firstColor}20 !important`,

		"&:hover": {
			backgroundColor: `${theme.palette.common.firstColor}10 !important`,
		},
	}
}))

export { Select }